import { makeCrud } from "./crud";
import { request } from "./http";

const crud = makeCrud("work-orders");

export const fetchWorkOrders  = (filters, signal) => crud.list(filters, signal);
export const fetchWorkOrder   = crud.get;
export const createWorkOrder  = crud.create;
export const updateWorkOrder  = crud.update;
export const deleteWorkOrder  = crud.remove;

export const updateWorkOrderStatus = (id, status) =>
  request(`/work-orders/${id}/status`, { method: "PATCH", body: { status } });

/** Generates an invoice from a (completed) work order. */
export const createInvoiceFromWorkOrder = (id) =>
  request(`/work-orders/${id}/invoice`, { method: "POST" });
